import { render } from "./AlternativeAddressShow.vue?vue&type=template&id=5acfae48"
import script from "./AlternativeAddressShow.vue?vue&type=script&setup=true&lang=js"
export * from "./AlternativeAddressShow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/AlternativeAddressShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5acfae48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5acfae48', __exports__)) {
    api.reload('5acfae48', __exports__)
  }
  
  module.hot.accept("./AlternativeAddressShow.vue?vue&type=template&id=5acfae48", () => {
    api.rerender('5acfae48', render)
  })

}


export default __exports__